export default {
    GET_COURSE_REQUEST: 'COURSE_EDIT_ADMINS_GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS: 'COURSE_EDIT_ADMINS_GET_COURSE_SUCCESS',
    USERS_REQUEST: 'COURSE_EDIT_ADMINS_USERS_REQUEST',
    USERS_SUCCESS: 'COURSE_EDIT_ADMINS_USERS_SUCCESS',
    UPDATE_COURSE_ADMINS_REQUEST: 'COURSE_EDIT_ADMINS_UPDATE_COURSE_ADMINS_REQUEST',
    UPDATE_COURSE_ADMINS_SUCCESS: 'COURSE_EDIT_ADMINS_UPDATE_COURSE_ADMINS_SUCCESS',
    UPDATE_COURSE_VIEWERS_REQUEST: 'COURSE_EDIT_ADMINS_UPDATE_COURSE_VIEWERS_REQUEST',
    UPDATE_COURSE_VIEWERS_SUCCESS: 'COURSE_EDIT_ADMINS_UPDATE_COURSE_VIEWERS_SUCCESS',
    SEARCH_ORGANIZATIONS_REQUEST: 'COURSE_EDIT_ADMINS_SEARCH_ORGANIZATIONS_REQUEST',
    SEARCH_ORGANIZATIONS_SUCCESS: 'COURSE_EDIT_ADMINS_SEARCH_ORGANIZATIONS_SUCCESS',
    USERS_RESET: 'COURSE_EDIT_ADMINS_USERS_RESET',
    ORGANIZATIONS_RESET: 'COURSE_EDIT_ADMINS_ORGANIZATIONS_RESET',
    DISPOSE: 'COURSE_EDIT_ADMINS_DISPOSE_STORE',
    COURSE_CONTRIBUTOR_DEFAULTS_REQUEST: 'COURSE_CONTRIBUTOR_DEFAULTS_REQUEST',
    COURSE_CONTRIBUTOR_DEFAULTS_SUCCESS: 'COURSE_CONTRIBUTOR_DEFAULTS_SUCCESS',
};
